/* TUQUE — theme.js
   Progressive enhancement only. Every feature here degrades to a working
   server-rendered page if JS fails. No dependencies. */
(function () {
  'use strict';

  var ready = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  ready(function () {

    /* ---------- shared slide-out drawer helper ---------- */
    // Used by both the mobile menu (slides from the right) and the search
    // drawer (slides from the left) — same open/close/focus/escape/overlay
    // behaviour, just a different drawer element and open/close triggers.
    function bindDrawer(opts) {
      var drawer = document.getElementById(opts.drawerId);
      var overlay = document.getElementById('Overlay');
      if (!drawer) return null;
      var openBtns = document.querySelectorAll('[' + opts.openAttr + ']');
      var closeBtns = document.querySelectorAll('[' + opts.closeAttr + ']');
      var lastFocus = null;

      function open() {
        lastFocus = document.activeElement;
        drawer.setAttribute('data-open', 'true');
        drawer.setAttribute('aria-hidden', 'false');
        if (overlay) overlay.hidden = false;
        document.body.style.overflow = 'hidden';
        openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
        var focusTarget = opts.focusSelector ? drawer.querySelector(opts.focusSelector) : null;
        if (!focusTarget) focusTarget = drawer.querySelector('a, button, input');
        if (focusTarget) focusTarget.focus();
        if (opts.onOpen) opts.onOpen();
      }
      function close() {
        drawer.setAttribute('data-open', 'false');
        drawer.setAttribute('aria-hidden', 'true');
        if (overlay) overlay.hidden = true;
        document.body.style.overflow = '';
        openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        if (lastFocus) lastFocus.focus();
      }
      openBtns.forEach(function (b) { b.addEventListener('click', open); });
      closeBtns.forEach(function (b) { b.addEventListener('click', close); });
      if (overlay) overlay.addEventListener('click', close);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') close();
      });
      return { open: open, close: close, drawer: drawer };
    }

    /* ---------- mobile drawer ---------- */
    bindDrawer({ drawerId: 'MobileDrawer', openAttr: 'data-menu-open', closeAttr: 'data-menu-close' });

    /* ---------- search drawer ---------- */
    (function () {
      var handle = bindDrawer({
        drawerId: 'SearchDrawer',
        openAttr: 'data-search-open',
        closeAttr: 'data-search-close',
        focusSelector: '#SearchDrawerInput'
      });
      if (!handle) return;

      var form = document.getElementById('SearchDrawerForm');
      var input = document.getElementById('SearchDrawerInput');
      var results = document.getElementById('SearchDrawerResults');
      if (!form || !input || !results) return;

      var endpoint = results.getAttribute('data-predictive-search-url');
      var noResultsText = input.getAttribute('data-no-results') || '';
      var viewAllText = input.getAttribute('data-view-all') || '';
      var timer = null;
      var controller = null;

      function render(query, html, hasResults) {
        var out = '';
        if (hasResults) {
          out += html;
          out += '<a class="btn btn--secondary btn--full search-drawer__viewall" href="'
            + form.getAttribute('action') + '?q=' + encodeURIComponent(query) + '">'
            + viewAllText + ' “' + query.replace(/</g, '&lt;') + '”</a>';
        } else if (query) {
          out += '<p class="search-drawer__empty">' + noResultsText + '</p>';
        }
        results.innerHTML = out;
      }

      function search(query) {
        if (controller) controller.abort();
        if (!query) { results.innerHTML = ''; return; }
        if (!endpoint) return;

        controller = (window.AbortController) ? new AbortController() : null;
        var url = endpoint + '?q=' + encodeURIComponent(query)
          + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last'
          + '&section_id=predictive-search';

        fetch(url, { signal: controller ? controller.signal : undefined })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var html = (data && data.resources && data.resources.results
              && data.resources.results.sections
              && data.resources.results.sections['predictive-search']) || '';
            var hasResults = /<li/.test(html);
            render(query, html, hasResults);
          })
          .catch(function () { /* aborted or offline — leave last results showing */ });
      }

      input.addEventListener('input', function () {
        var query = input.value.trim();
        clearTimeout(timer);
        timer = setTimeout(function () { search(query); }, 220);
      });

      // Enter still submits to the full /search results page — the drawer
      // never intercepts that, it only supplies the live preview above it.
    })();

    /* ---------- language switcher ---------- */
    document.querySelectorAll('[data-switcher]').forEach(function (root) {
      var btn = root.querySelector('[data-switcher-btn]');
      var panel = root.querySelector('[data-switcher-panel]');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
      });
      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) {
          btn.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
        }
      });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          btn.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
          btn.focus();
        }
      });
    });

    /* ---------- login / recover toggle ---------- */
    (function () {
      var toggles = document.querySelectorAll('[data-auth-toggle]');
      var login = document.getElementById('LoginForm');
      var recover = document.getElementById('RecoverPassword');
      if (!toggles.length || !login || !recover) return;
      if (window.location.hash === '#recover') {
        login.style.display = 'none';
        recover.style.display = 'block';
      }
      toggles.forEach(function (t) {
        t.addEventListener('click', function () {
          var showRecover = recover.style.display === 'none' || recover.style.display === '';
          recover.style.display = showRecover ? 'block' : 'none';
          login.style.display = showRecover ? 'none' : 'block';
        });
      });
    })();

    /* ---------- quantity steppers ---------- */
    document.querySelectorAll('.qty').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.querySelectorAll('[data-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-qty') === '+' ? 1 : -1;
          var min = parseInt(input.getAttribute('min') || '1', 10);
          var next = (parseInt(input.value, 10) || min) + step;
          input.value = next < min ? min : next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    /* ---------- product gallery ---------- */
    (function () {
      var main = document.getElementById('ProductMainImage');
      var thumbs = document.querySelectorAll('[data-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          main.src = t.getAttribute('data-full');
          thumbs.forEach(function (o) { o.removeAttribute('aria-current'); });
          t.setAttribute('aria-current', 'true');
        });
      });
    })();

    /* ---------- variant picker ---------- */
    (function () {
      var dataEl = document.getElementById('ProductVariants');
      var idInput = document.getElementById('ProductVariantId');
      var addBtn = document.getElementById('AddToCart');
      var priceEl = document.getElementById('ProductPrice');
      if (!dataEl || !idInput) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var selects = document.querySelectorAll('select[data-option-position]');
      if (!selects.length) return;

      function money(cents) {
        var fmt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-CA',
            { style: 'currency', currency: fmt }).format(cents / 100);
        } catch (e) {
          return (cents / 100).toFixed(2);
        }
      }

      function selected() {
        var opts = [];
        selects.forEach(function (s) {
          opts[parseInt(s.getAttribute('data-option-position'), 10) - 1] = s.value;
        });
        return opts;
      }

      function variantIsAvailable(testOpts) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var j = 0; j < testOpts.length; j++) {
            if (testOpts[j] && v.options[j] !== testOpts[j]) { ok = false; break; }
          }
          if (ok && v.available) return true;
        }
        return false;
      }

      // Grey out and label (in both languages via data attrs) any <option>
      // that has no available variant given the *other* selects' current
      // values, so a sold-out size/colour reads as sold out before you add
      // to cart, not just at checkout.
      function markAvailability() {
        var opts = selected();
        selects.forEach(function (s) {
          var pos = parseInt(s.getAttribute('data-option-position'), 10) - 1;
          Array.prototype.forEach.call(s.options, function (opt) {
            var testOpts = opts.slice();
            testOpts[pos] = opt.value;
            var available = variantIsAvailable(testOpts);
            opt.disabled = !available;
            if (!opt.getAttribute('data-label')) opt.setAttribute('data-label', opt.textContent);
            var label = opt.getAttribute('data-label');
            var soldOutSuffix = ' — ' + (document.documentElement.lang === 'fr' ? 'Épuisé' : 'Sold out');
            opt.textContent = available ? label : label + soldOutSuffix;
          });
        });
      }

      function update() {
        var opts = selected();
        var match = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var j = 0; j < opts.length; j++) {
            if (opts[j] && v.options[j] !== opts[j]) { ok = false; break; }
          }
          if (ok) { match = v; break; }
        }
        if (!match) return;

        idInput.value = match.id;

        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());

        if (priceEl) {
          var html = '<span class="price' + (match.compare_at_price > match.price ? ' price--sale' : '') + '">';
          if (match.compare_at_price > match.price) {
            html += '<s class="price__was">' + money(match.compare_at_price) + '</s>';
          }
          html += money(match.price) + '</span>';
          priceEl.innerHTML = html;
        }

        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = addBtn.getAttribute('data-' + (match.available ? 'available' : 'soldout'))
            || addBtn.textContent;
        }
      }

      selects.forEach(function (s) {
        s.addEventListener('change', function () { markAvailability(); update(); });
      });

      // Reflect availability and the pre-selected/default variant immediately,
      // not only after the shopper first touches a dropdown.
      markAvailability();
      update();
    })();

    /* ---------- collection sort by brand / brand location ---------- */
    (function () {
      // Shopify's native collection sort_by only understands its own sort
      // keys (title, price, created, best-selling…) — there's no built-in
      // way to sort a collection by vendor or by a metafield. So "Brand A–Z"
      // and "Brand location A–Z" are handled entirely client-side: they
      // reorder the product cards already on the page instead of reloading
      // with an unsupported sort_by value. Native sort options still submit
      // the form as normal and reload with the new server-side order.
      var select = document.getElementById('SortBy');
      var grid = document.getElementById('ProductGrid');
      if (!select) return;

      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        var key = opt.getAttribute('data-client-sort');
        if (!key) { if (select.form) select.form.submit(); return; }
        if (!grid) return;

        var attr = key === 'vendor' ? 'data-vendor' : 'data-brand-location';
        var dir = opt.getAttribute('data-dir') === 'desc' ? -1 : 1;
        var items = Array.prototype.slice.call(grid.children);

        items.sort(function (a, b) {
          var cardA = a.querySelector('.card');
          var cardB = b.querySelector('.card');
          var av = (cardA && cardA.getAttribute(attr)) || '';
          var bv = (cardB && cardB.getAttribute(attr)) || '';
          if (av === '' && bv === '') return 0;
          if (av === '') return 1;
          if (bv === '') return -1;
          return av.localeCompare(bv, undefined, { sensitivity: 'base' }) * dir;
        });

        items.forEach(function (li) { grid.appendChild(li); });
      });
    })();

    /* ---------- live cart count ---------- */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = '…'; }

      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          if (btn) { btn.disabled = false; btn.textContent = original; }
        })
        .catch(function () {
          form.removeEventListener('submit', arguments.callee);
          form.submit();
        });
    });

  });
})();
